// Shared INPUT/OUTPUT visual treatment for event analytics views.
// INPUT  -> blue, OUTPUT -> green, so the user can tell the resource direction
// at a glance.
export const resourceTypeMeta = (type) => {
  const key = (type || '').toString().trim().toUpperCase();
  if (key === 'INPUT') {
    return {
      label: 'INPUT',
      colorClass: 'text-blue-300',
      dotClass: 'bg-blue-300',
      icon: 'el-icon-download',
    };
  }
  if (key === 'OUTPUT') {
    return {
      label: 'OUTPUT',
      colorClass: 'text-green-400',
      dotClass: 'bg-green-400',
      icon: 'el-icon-upload2',
    };
  }
  return {
    label: key || '-',
    colorClass: 'text-white/60',
    dotClass: 'bg-white/40',
    icon: 'el-icon-connection',
  };
};

export default resourceTypeMeta;
